<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>CCMS Testing</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="download()">Download</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perpage" id="perPageSelect" :options="pageoptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterinput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterinput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentpage" :per-page="perpage" :filter="filter" :filterIncludedFields="filteron" :sort-by.sync="sortby" :sort-desc.sync="sortdesc" :sort-direction="sortdirection" @filtered="onfiltered">
									<template v-slot:cell(ulb_id)="row">
										<b-label>{{getUlbLabel(row.value)[0].title}}</b-label>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showModal(row.item, row.index, $event.target)" size="sm">Show</b-button>
										<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentpage}} to {{(perpage>records.length)?records.length:perpage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentpage" pills :total-rows="totalrows" :per-page="perpage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<b-modal id="show-modal" size="xl" title="BootstrapVue">
			<p style="width:100%; word-wrap:break-word;">{{selectedItem.datastring}}</p>
			<p style="width:100%; word-wrap:break-word;">{{selectedItem.convertstring}}</p>
			<b-container>
				<b-row>
					<b-col>
						<b-form-radio-group v-model="datatype" class="mb-3">
							<b-form-radio value="2G">2G</b-form-radio>
							<b-form-radio value="4G">4G</b-form-radio>
						</b-form-radio-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						{{meter_phase_type}}
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'CCMS Testing',
	components: {
		"top-header": Header
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
            interval: '',
			email: '',
			password: '',
            url: self.$session.get('apiurl')+'esmartapi/ccms-testing',
			records: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'imei_no', label: 'IMEI'},
				{ key: 'datalength', label: 'Data Length',
                    formatter: (value, key, item) => {
						return item.datastring.length;
					},
                },
				{ key: 'insert_time', label: 'Timestamp',
                    formatter: (value) => {
						return self.$moment(value).format('DD-MM-YYYY HH:mm');
					},
                },
				{ key: 'actions', label: '', extra: 1},
			],
			totalrows: 1,
			currentpage: 1,
			pageoptions: [10, 20, 50, 100],
			perpage: 10,
			sortby: '',
			sortdesc: false,
			sortdirection: 'asc',
			filter: null,
			filteron: [],
			datatype: '2G',
			meter_phase_type: 1,
			selectedItem: {}
		};
	},
	methods: {
		showModal(item){
			this.selectedItem = Object.assign({}, item);
			
			var buff = Buffer.from(this.selectedItem.datastring, 'utf8');
			var hexdata = buff.toString('hex');
			//console.log('ORIGINAL: ' + data);
			console.log('HEX: ' + hexdata);
			var regExp = /(?<=5b)(.*)(?=5d)/;
			var matches = hexdata.match(regExp);
			
			if(matches.length > 0){
				var d = matches[0];
				this.selectedItem.convertstring = d;

				var devicetype = d.toUpperCase().indexOf("53504D");

				if(devicetype > 0){
					this.meter_phase_type = 1;
				}else{
					this.meter_phase_type = 3;
				}
			}
					
			this.$root.$emit('bv::show::modal', 'show-modal');
		},
		initload(){
			var self = this;
			
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result;
					self.loading = false;
					self.totalrows = self.records.length;

					
					self.interval = setTimeout(self.initload, 1000 * 10);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onfiltered(filteredItems) {
			this.totalrows = filteredItems.length
			this.currentpage = 1
		},
		download(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key == 'datalength'){
						dataarr.push(row.datastring.length);
					}else{
                        dataarr.push(field);
                    }
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "ccms_testing.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>